<!-- listBoxInputMulti.vue -->

<template>
  <div>
    <div class="form-floating">
        <div class="selected-values-container" @click="focusInput">
            <span class="selected-value" v-for="(value, index) in selectedValues" :key="index">
                {{ value }} <i class="fas fa-times" @click.stop="removeValue(index)"></i>
            </span>
            <input 
                ref="multiSelectInput"
                v-model="searchText"
                :class="['form-control', 'multi-select-input', formData.fields[fieldName].class]"
                @input="searchList"
                :name="name"
                @blur="leaveFromInput"
                @focus="inToInput"
                @keydown.enter.prevent="searchTexto"
                :id="formData.fields[fieldName].id"
                :required="formData.fields[fieldName].required && selectedValues.length === 0"
                autocomplete="off"
                :placeholder="selectedValues.length ? '' : 'Escribe una ' + formData.fields[fieldName].label"
            />
        </div>
        <label :for="formData.fields[fieldName].id">{{ formData.fields[fieldName].label }}</label>
        <div @click="clearInput"><i class="fas fa-times clear-input" ></i></div>
        <div v-show="isLoading" class="loading-icon"><i class="fas fa-cog fa-spin"></i></div>
    </div>
    <ul @mouseenter="overList" @mouseleave="leaveList" v-if="showListToSelect" class="list-group shadow-lg mt-2">
        <li 
            v-for="regList in matchingValues"
            :key="regList.id_"
            @click="selectValue(regList)"
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
            >
            <span v-if="!searchIn.show">{{ regList[searchIn.field] }} <div v-if="searchIn.show" class="pl-2 border h5">{{ regList[searchIn.show] }}</div></span>
            <span v-if="searchIn.show" class="" v-html="prepareShow(regList, searchIn.show)"></span>
        </li>
    </ul>
  </div>
</template>


<script>
const { replaceKeys } = require('@/js/utils.js');

export default {
    props: {
        fieldData: { type: Object, required: true },
        formValues: { type: Object, },
        formData: { type: Object, required: true },
        fieldName: { type: String, required: true },
        name: {type: String}
    },
  watch: {
    fieldData(newVal, oldVal) {
        if (newVal !== oldVal) {
            this.selectedValues = newVal ? newVal.split(',') : [];
        }
    }
    },
  mounted() {
    this.selectedValues = this.fieldData ? this.fieldData.split(',') : [];
  },
  computed: {
        fieldValue() {
            return this.fieldData;
        },
        showListToSelect() {
            return this.showList;
        }
   },
  data() {
    return {
      searchIn : this.formData.fields[this.fieldName].component,
      showList: false,
      swOverList: false,
        lastSearch: "",
        searchText: '',
        selectedValues: [],
        matchingValues: []
    };
  },
  methods: {
    async searchList() {

       if (this.formData.fields[this.fieldName].alwaysList) return;
       if (this.searchText.length < 3  ) return ;

       this.searchText = this.checkCase(this.searchText);
       if (this.searchText == this.lastSearch ) return ;

       this.searchListFrom();
    },
    async searchTexto() {
        if (this.formData.fields[this.fieldName].alwaysList) return;
        if (this.searchText.length < 1  ) return ;
         this.searchText = this.checkCase(this.searchText);
       if (this.searchText == this.lastSearch ) return ;

       this.searchListFrom();
    },
    async overList() {
        this.swOverList=true;
    },
    async leaveList() {
        this.swOverList=false;
    },
    inToInput() {
        if (!this.searchTex) this.searchTex = "";
        console.log("inToInput:",this.searchIn,this.matchingValues.length)
        if (this.searchIn.alwaysList && (this.matchingValues.length==0 || !this.matchingValues)) {
            this.searchListFrom();
            return
        }
        if (!this.showList && this.matchingValues.length>0 ) this.showList = true;

        if (this.searchText.length < 3 ) return;

        if (this.searchText.length >= 3 && this.lastSearch != this.searchText )  this.searchListFrom();
        if (this.searchText.length >= 3 && this.lastSearch == this.searchText && this.matchingValues.length > 0 ) this.showList=true;
    },
    async leaveFromInput() {
        if (! this.swOverList) {
            this.showList=false;
            if (this.searchText != this.fieldData) this.searchText= (this.fieldData) ? this.fieldData : "";
        }
    },
    async searchListFrom() {
        console.log("searchListFrom....", this.searchIn.alwaysList)
        if (!this.matchingValues) this.matchingValues = [];
        if (this.matchingValues.length > 0 && this.searchIn.alwaysList) { this.showList = true; return; }
        this.showList = false;

       if (this.searchIn.from === "FS")  this.matchingValues = await this.getFirestore(this.searchIn);
       else  if (this.searchIn.from.toLowerCase() === "api") this.matchingValues = await this.getFromApi(this.searchIn);
       else this.matchingValues = (this.searchIn.options) ? this.searchIn.options : [];
       if (this.matchingValues.length>0) this.showList = true;
       else this.showList=false;
    },
    async getFirestore(searchIn) {
        let query = this.$Genv.fsCia.collection(searchIn.collection)
        if (this.searchText.length > 0 && !this.searchIn.alwaysList) {
            query = query.where(searchIn.field, ">=", this.searchText).where(searchIn.field, "<=", this.searchText + "\uf8ff")
            this.lastSearch = this.searchText;
        }
        const dataCol = await query.get(true);
        return this.prepareListToSelect(dataCol, searchIn);
      },
      async getFromApi(searchIn) {
        console.log("searchIn.params:",searchIn.params)
        const params = {...{"term":this.searchText}, ...{"params": (searchIn.params) ? replaceKeys(searchIn.params,this.formValues): ""}}
        console.log("searchIn=>params:",params)

        const st = await this.$ajax(searchIn.action || searchIn.collection,params,"terms" )
        console.log("getFromApi:"+searchIn.action, st)
        return this.prepareListToSelect(st.data, searchIn);
    },
      prepareListToSelect(dataCol, searchIn) {
        console.log("prepareListToSelect:",dataCol)
        const isVarFields = /{{[\w\-_]+}}/.test(searchIn.key);
        const vars = (isVarFields) ? this.$arMatchs(searchIn.key) : false;
        //console.log("Col:"+searchIn.collection+" field:"+searchIn.field+" search:"+this.searchText+" l:"+this.searchText.length," data:",dataCol)
       
        const data = ((j,C) => {
                for (let c in C ) {
                    const key = (isVarFields ) ? this.getKey(vars,C[c],searchIn.key) : C[c][searchIn.key];
                    j[key]=C[c];
                } 
                return j
            })({}, dataCol)
        let rt = ((j, C) => { for (let c in C) j.push(C[c]); return j })([], data);
        console.log("LIST:",rt)
        return rt;
        //return ((j,C) => {for (let c in C) j.push(C[c]); return j})([],data) ;
    },

    getKey(vars,data,key) {
       let strKey=key;
       // eslint-disable-next-line no-useless-escape
       for (let v in vars) strKey = strKey.replace(new RegExp("\{\{"+vars[v]+"\}\}","gm"),data[vars[v]])
        return strKey;
      },
    selectValue(regList) {
        const valueToAdd = regList[this.searchIn.field];
        if (!this.selectedValues.includes(valueToAdd)) {
            this.selectedValues.push(valueToAdd);
            this.emitSelectedValues();
        }
        this.searchText = '';
        this.showList = false;
    },
    removeValue(index) {
        this.selectedValues.splice(index, 1);
        this.emitSelectedValues();
    },

    clearInput() {
        this.searchText = ''; // Limpia el campo de entrada
        this.selectedValues = []; // Limpia todos los valores seleccionados
        this.emitSelectedValues();
        this.selectregList({[this.fieldName]:""});
    },
    selectregList(regList) {
        this.showList=false;
        if (!this.searchIn.set) this.searchIn.set = {[this.fieldName]: this.searchIn.field}
        if (!this.searchIn.set[this.fieldName]) this.searchIn.set[this.fieldName] =  this.searchIn.field;
        const json = {...this.searchIn.set}

        for (const f in json) json[f] =  (!json[f]) ? "" : regList[json[f]] || null ;

        this.$emit('input-change',  this.selectedValues.join(','));
        return;
      //this.matchingValues = [];
    },
    prepareShow(regList,showStr) {
        return replaceKeys(showStr, regList);
    },
    checkCase(inputValue) {
        const currentClass = this.formData.fields[this.fieldName].class;

        if (currentClass.includes('uppercase')) {
            inputValue = inputValue.toUpperCase();
        } else if (currentClass.includes('downcase')) {
            inputValue = inputValue.toLowerCase();
        }

        return inputValue;
      }
  }
};
</script>

<style scoped>
.uppercase { text-transform: uppercase; }
.lowercase { text-transform: lowercase; }
.capitalize {text-transform: capitalize; }
.selected-values-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 5px;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    background-color: #fff;
}

.selected-value {
    background-color: #e9ecef;
    border-radius: 20px;
    padding: 2px 10px;
    margin-right: 5px;
    margin-bottom: 5px;
    font-size: 0.875rem;
}

.multi-select-input {
    flex: 1;
    border: none;
    margin-bottom: 0;
    padding-left: 0;
    padding-right: 0;
    box-shadow: none;
}

.form-floating > .selected-values-container:focus-within {
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25);
}

.clear-input {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    color: #ccc;
}

.clear-input:hover {
    color: #666;
}

</style>
